<template>
    <div class="label-manage-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="label-manage-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">标签管理</span>
            </div>
            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">标签名称</span>
                        <el-input placeholder="请输入标签名称"
                                  @keyup.enter.native="searchQuery"
                                  v-model="selectForm.name"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label">创建时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="searchQuery">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetQuery">重置</el-button>
                    </div>
                </div>
                <div>
                    <el-button size="small"
                               @click="editLabel('add')">新增标签</el-button>
                </div>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="50px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     min-width="180px"
                                     label="标签名称">
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.createTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount"
                                     min-width="90px"
                                     label="课程数">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.amount || 0 }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="操作"
                                     width="160">
                        <template slot-scope="scope">
                            <span @click="editLabel('edit',scope.row)"
                                  class="link-btn">编辑</span>
                            <span @click="handleClick(scope.row.labelId)"
                                  class="link-btn">删除</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>

                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="editType=='add'?'新增标签':'编辑标签'"
                   :visible.sync="isEditShow"
                   custom-class="label-dialog"
                   width="400px">
            <el-form :model="labelForm"
                     label-width="80px"
                     :rules="labelRules"
                     class="form-wrap"
                     ref="labelForm">
                <el-form-item label="标签名称"
                              prop="name">
                    <el-input v-model.trim="labelForm.name"
                              placeholder="请输入标签名称"
                              :style="{width: '250px'}"
                              maxlength="15"
                              size="small"></el-input>
                </el-form-item>
                <div class="dialog-btn-label-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="saveForm()">保 存</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelForm">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <message-box :dialog-visible="dialogVisible"
                     :id="labelId"
                     warning-text="确认将此标签删除？"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
    </div>
</template>

<script>
import shortcuts from '@/utils/pickerOptions'
import MessageBox from '@/components/MessageBox'
import { postEditLabel, postLabelList, deleteLabel } from '@/api/labelManage'
export default {
    name: 'labelManage',
    data () {
        return {
            loading: false,
            breadList: [{ label: '运营管理' }, { label: '标签管理' }],
            selectForm: {
                name: '',
                createTime: ''
            },
            datePickerOptions: {
                shortcuts: shortcuts
            },
            dataList: [],
            dialogVisible: false,
            labelId: '',
            editType: 'add',
            editLabelObj: null,
            isEditShow: false,
            labelForm: {
                name: ''
            },
            labelRules: {
                name: [{ required: true, message: '请输入标签名称！', trigger: 'blur' }, { required: true, message: '请输入医生集团名称！', trigger: 'change' }]
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            }
        }
    },
    components: {
        MessageBox
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        editLabel (type, item) {
            this.editType = type
            if (this.labelForm.name) {
                this.labelForm.name = ''
                this.$nextTick(() => {
                    this.$refs['labelForm'].clearValidate()
                })
            }

            if (type === 'edit') {
                this.editLabelObj = item
                this.labelForm.name = item.name
            }
            this.isEditShow = true
        },
        cancelForm () {
            this.labelForm.name = ''
            this.$nextTick(() => {
                this.$refs['labelForm'].clearValidate()
            })
            this.isEditShow = false
        },
        saveForm () {
            this.$refs['labelForm'].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    return false
                }
            })
        },
        async submit () {
            const param = {
                name: this.labelForm.name
            }
            if (this.editType === 'edit') {
                param.labelId = this.editLabelObj.labelId
            }
            const { results, state } = await postEditLabel(param)
            if (results && state === 200) {
                if (this.editType === 'edit') {
                    this.$message.success('修改成功！')
                } else {
                    this.$message.success('新增成功！')
                }
            }

            this.isEditShow = false
            this.query(1)
        },
        handlePageChange (val) {
            this.query(val)
        },
        searchQuery () {
            this.query(1)
        },
        resetQuery () {
            this.selectForm.name = ''
            this.selectForm.createTime = ''
            this.query(1)
        },
        handleClick (labelId) {
            this.labelId = labelId
            this.dialogVisible = true
        },
        addLabel () {},
        async handleConfirm () {
            this.dialogVisible = false
            this.loading = true
            const { state } = await deleteLabel(this.labelId)
            if (state === 200) {
                this.$message.success('删除标签成功！')
                // 如果当页都删除完了 需要更改current
                let { total, current, pageSize } = this.page
                const newCurrent = Math.ceil((total - 1) / pageSize)
                this.page.current = newCurrent < current ? newCurrent : newCurrent
                this.query(this.page.current)
            }
        },
        handleClose () {
            this.dialogVisible = false
        },
        query (val) {
            this.page.current = val
            this.queryList()
        },
        async queryList () {
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }
            let params = {
                name: this.selectForm.name,
                startTime: createTimeStart,
                endTime: createTimeEnd,
                current: this.page.current,
                size: this.page.pageSize
            }
            this.loading = true
            this.dataList = []
            const { results, state } = await postLabelList(params)
            if (results && state === 200) {
                this.page.total = results.total
                this.dataList = results.records
            }
            this.loading = false
        },
        init () {
            this.queryList()
        }
    }
}
</script>

<style lang="scss">
.label-manage-wrap {
    height: 100%;
    .label-manage-content {
        height: calc(100% - 91px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 56px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }
        .link-btn {
            cursor: pointer;
            color: $a-link;
            font-size: 12px;
            display: inline-block;
            height: 14px;
            line-height: 14px;
            border-right: 1px solid $a-link;
            margin-right: 6px;
            padding-right: 6px;
            &:last-child {
                border-right: none;
                margin-right: 0;
                padding-right: 0;
            }
        }
    }
    .label-dialog {
        .el-dialog__body {
            display: flex;
            justify-content: center;
        }
        .el-form-item {
            margin-bottom: 24px;
            &.is-error {
                margin-bottom: 30px;
            }
        }
        .form-wrap {
            display: inline-block;
        }
        .dialog-btn-label-wrap {
            padding: 0 20px 24px 80px;
            text-align: left;
            .el-button {
                width: 96px;
                font-size: 14px;
            }
            .el-button--info.is-plain {
                background-color: #f5f5f5;
                border-color: #dbdbdb;
                color: #666;
            }
        }
    }
}
</style>
